<script>
import { mapGetters, mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Files'
    },

    extends: TableView,

    data() {
        return {
            mainClass: 'files-table',
            pageTitle: 'Files',
            actions: [
                {
                    icon: 'fas fas fa-download',
                    method: 'downloadFile'
                }
            ]
        };
    },

    computed: {
        ...mapGetters({
            ALL_STATUSES: 'files/ALL_STATUSES'
        }),

        options() {
            return { addButton: false };
        },

        labels() {
            return [
                {
                    value: 'number',
                    text: 'File ID',
                    type: 'number',
                    width: '150px',
                    filterFieldName: 'number'
                },
                {
                    value: 'user.campuses',
                    text: "User's campus",
                    width: '200px',
                    filterFieldName: 'user.campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'academicCourse',
                    text: 'Course',
                    width: '150px',
                    filterFieldName: 'academicCourse.name',
                    sortFieldName: 'academicCourse.name',
                    filter: v => `${v.name} (${v.number})`
                },
                {
                    value: 'fileType',
                    text: 'Category',
                    filterFieldName: 'fileType',
                    filter: v => v.toUpperCase(),
                    width: '150px'
                },
                {
                    value: 'year',
                    filterFieldName: 'year',
                    width: '150px'
                },
                {
                    value: 'term',
                    filterFieldName: 'term',
                    width: '150px'
                },
                {
                    value: 'type',
                    filterFieldName: 'type',
                    text: 'File type',
                    width: '150px'
                },
                {
                    value: 'status',
                    width: '150px',
                    type: 'enum',
                    enumOptions: this.ALL_STATUSES.map(({ text }) => text)
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                { value: 'media.name', text: 'File Name', width: '150px' },
                { value: 'likesThreshold', type: 'number', width: '150px' },
                { value: 'starsAmount', type: 'number', width: '150px' },

                { value: 'likes', type: 'number', width: '150px' },
                {
                    value: 'areStarsAdded',
                    type: 'boolean',
                    isBadge: true,
                    width: '150px'
                },

                {
                    value: 'isReported',
                    type: 'boolean',
                    isBadge: true,
                    badgeOptions: {
                        trueVariant: 'danger',
                        falseVariant: 'success'
                    },
                    width: '150px'
                },
                {
                    value: 'user.fullName',
                    sortFieldName: 'user.firstName',
                    text: 'Creator',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'files/index',
            deleteItem: 'files/destroy',
            approveFile: 'files/approve'
        }),

        onRowClick({ id }) {
            this.$router.push(`/files/${id}/edit`);
        },

        getRowClass({ status }) {
            return `${status}-item`;
        },

        downloadFile(id) {
            const file = this.items.find(file => file.id === id);

            this.$downloadFile(this.$getFileUrl(file.media));
        },

        async approve(id, index) {
            try {
                await this.approveFile(id);

                this.items.splice(index, 1, {
                    ...this.items[index],
                    isApproved: true
                });

                this.$toaster('File has been approved');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
